module.exports = __webpack_public_path__ + "img/shake_box.15221544.png";